import { ReactNode, ElementType } from 'react';

export interface HtmlGenericElementProps {
  as?: ElementType;
  children?: ReactNode;
  [key: string]: any;
}

export const HtmlGenericElement = (props: HtmlGenericElementProps) => {
  const { as: Component = 'div', children, ...rest } = props;
  return <Component {...rest}>{children}</Component>;
};
